import { createAxiosInstance } from "api/axiosConfig.js";

export const fetchImmunizations = async (tenantVal, patientId) => {
  const axiosInstance = createAxiosInstance();
  const response = await axiosInstance.get(
    `${tenantVal}/patientimmunisation/getbypatientid/${patientId}`
  );
  return response.data;
};
